import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { strings } from "../../../utils/strings";
import { Tooltip } from "antd";
import apiService from "../../../../service/apiservice/apiService";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";
import ModalFormRendererComponent from "../../../generic/forms/ModalFormRendererComponent";
import { complianceFormTemplateCode } from "../../../../components/recoil/complianceFormTemplateCodeRecoil";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";

const Compliance = ({ carePlanId }) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [complianceData, setComplianceData] = useState({});
  const [carePlan, setCarePlan] = useState({});
  const templateCode = useRecoilValue(complianceFormTemplateCode);

  const handleOnClick = async () => {
    const endpoint = "niramayafoundation/niramayavisits/api/v1/careplans";
    const params = {
      organizationIdentifier,
      carePlanId,
    };
    const response = await apiService.get(endpoint, params);
    const result = response[0];
    const ehrMetadata = result?.ehrMetadata && JSON.parse(result?.ehrMetadata);

    setCarePlan(result);
    setComplianceData(ehrMetadata);
    setIsModalVisible(true);
  };

  const onDataSubmitCallback = async (data) => {
    const payload = {
      ...carePlan,
      ehrMetadata: JSON.stringify(data),
    };
    await apiService.post(
      "niramayafoundation/niramayavisits/api/v1/careplan",
      payload,
      strings.UPDATE_OPPORTUNITY_SUCCESS,
      strings.UPDATE_OPPORTUNITY_ERROR,
    );

    setIsModalVisible(false);
  };

  return (
    <>
      <Tooltip title="Compliance" placement="bottom">
        <>
          <SmartIcon iconKey={"compliance"} handleIconClick={handleOnClick} />
        </>
      </Tooltip>

      {isModalVisible && (
        <ModalFormRendererComponent
          isModalOpen={isModalVisible}
          footer={null}
          templateCode={templateCode}
          formIdentifier={complianceData?.formIdentifier}
          formSubmitCallback={onDataSubmitCallback}
          setIsModalOpen={setIsModalVisible}
        />
      )}
    </>
  );
};

export default Compliance;
